import React, { useState, useEffect } from 'react';
import { get as _get } from 'lodash';
import { ForgeBadge } from '@tylertech/forge-react';
const HeaderGreetingMessage = () => {
    const completeGreetingMessage = 'Data Assistant';
    const [displayedGreetingText, setDisplayedGreetingText] = useState('');
    useEffect(() => {
        let currentIndex = 0;
        const streamingInterval = 5;
        const intervalId = setInterval(() => {
            const nextGreetingTextCharacter = _get(completeGreetingMessage, `[${currentIndex}]`, '');
            setDisplayedGreetingText(currentText => currentText + nextGreetingTextCharacter);
            currentIndex++;
            if (currentIndex >= completeGreetingMessage.length) {
                clearInterval(intervalId);
            }
        }, streamingInterval);
        return () => clearInterval(intervalId);
    }, []);
    return (React.createElement("div", { className: "layer-content-greeting-message-container" },
        React.createElement("div", { className: "layer-content-greeting-container" },
            React.createElement("div", null, displayedGreetingText),
            React.createElement(ForgeBadge, null, "Beta"))));
};
export default HeaderGreetingMessage;
//# sourceMappingURL=HeaderGreetingMessage.js.map